import React from 'react';
import { Factory, Heart, Building2, Landmark } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const IndustriesSection = () => {
  const { t } = useLanguage();

  const icons = [Factory, Heart, Building2, Landmark];
  const colors = [
    { bg: 'bg-amber-100', icon: 'text-amber-700', border: 'border-amber-200' },
    { bg: 'bg-rose-100', icon: 'text-rose-600', border: 'border-rose-200' },
    { bg: 'bg-blue-100', icon: 'text-blue-600', border: 'border-blue-200' },
    { bg: 'bg-emerald-100', icon: 'text-emerald-600', border: 'border-emerald-200' }
  ];

  return (
    <section id="industries" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-700 font-medium mb-4 block">{t.industries.subtitle}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">{t.industries.title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.industries.description}
          </p>
        </div>

        {/* Industries Horizontal Layout */}
        <div className="flex flex-col md:flex-row gap-6 justify-center">
          {t.industries.items.map((industry, index) => {
            const Icon = icons[index];
            const color = colors[index];
            return (
              <div 
                key={index}
                className={`flex-1 min-w-0 group relative bg-white rounded-2xl p-6 border ${color.border} hover:shadow-xl transition-all duration-500 cursor-pointer`}
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl ${color.bg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className={`w-7 h-7 ${color.icon}`} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-amber-700 transition-colors">
                  {industry.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {industry.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;